<template>
    <div >
<!--        <about-menu @aboutSelect="aboutSelect"></about-menu>-->
        <router-view @aboutSelect="aboutSelect"></router-view>
    </div>
</template>

<script>
// import AboutMenu from "../components/AboutMenu";
export default {
	components: {
	    // AboutMenu
    },
	data() {
		return {

        }
	},
	mounted(){
        // this.$router.push({
		// 	path:'/about/introduction'
		// })
	},
    methods:{
        aboutSelect(src){
            if (src.indexOf('/img') > -1){
	            return
            }
            this.$router.push({
                path:src
            })
        }
    }
}
</script>

<style lang="less" scoped>

</style>
